import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { journalsService } from '../services/journals.service';
import type { CreateJournalPayload, UpdateJournalPayload } from '../types/api.types';
import toast from 'react-hot-toast';

export const useJournals = () =>
  useQuery({
    queryKey: ['journals'],
    queryFn: () => journalsService.listJournals(),
    staleTime: 1000 * 60 * 5,
  });

export const useCreateJournal = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateJournalPayload) => journalsService.createJournal(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['journals'] });
      toast.success('Journal created!');
    },
    onError: () => toast.error('Failed to create journal'),
  });
};

export const useUpdateJournal = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateJournalPayload }) =>
      journalsService.updateJournal(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['journals'] });
      toast.success('Journal updated!');
    },
    onError: () => toast.error('Failed to update journal'),
  });
};

export const useDeleteJournal = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => journalsService.deleteJournal(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['journals'] });
      toast.success('Journal deleted');
    },
    onError: () => toast.error('Failed to delete journal'),
  });
};
